<div class="grid-x">
  <div class="cell small-10 padding-right">
    <p>
      Add an entity using the 'Add Entity' button.  Edit the entity's properties using the pencil ( <svg-icon icon="icon-pencil" class="tiny medium-gray" aria-hidden="true"></svg-icon> <span class="show-for-sr">'Edit Entity Map'</span>) button.
      To delete an entity, use the trash ( <svg-icon icon="icon-trash" class="tiny medium-gray" aria-hidden="true"></svg-icon> <span class="show-for-sr">'Delete Entity Map'</span>) button.
    </p>
  </div>
  <div class="cell small-2">
    <button class="button" attr.aria-label="Import Workflow" (click)="beginImport()">Import Entity Map File <svg-icon class="small white" icon="icon-upload"></svg-icon></button>
  </div>
  <div class="cell small-12">
    <label for="selectEntity">Select Entity:</label>
    <div class="input-group">
      <select class="white-bg no-margin" [(ngModel)]="entityToAdd" id="selectEntity">
        @for (entity of availableEntities; track entity) {
          <option [value]="entity.id">{{entity.entityName}}</option>
        }
      </select>
      <div class="input-group-button">
        @if (addEntityButtonDisabled) {
          <span class="show-for-sr">Please Select An Entity To Enable This Button</span>
        }
        <button class="button" [attr.aria-label]="addEntityButtonDisabled ? 'Please Select An Entity To Enable This Button' : null" (click)="addEntity()" [disabled]="addEntityButtonDisabled">Add Entity</button>
      </div>
    </div>
  </div>
</div>
<hr class="border-bottom-medium-gray" />
<h4>Entity List</h4>

@for (map of template.entityMaps; track map; let index = $index) {
  <div>
    <div class="grid-x">
      <div class="cell small-12">
        <span>{{map.mapName}}</span>
        <button class="float-right" title="Delete" (click)="deleteMap(map.mapName, index)" attr.aria-label="Delete Entity Map {{map.mapName}}">
          <span class="show-for-sr">Delete Entity map {{map.mapName}}</span>
          <svg-icon icon="icon-trash" class="tiny medium-gray" aria-hidden="true"></svg-icon>
        </button>
        <button class="float-right" title="Edit" (click)="editMap(map.id)" attr.aria-label="Edit Entity Map {{map.mapName}}">
          <span class="show-for-sr">Edit Entity Map {{map.mapName}}</span>
          <svg-icon icon="icon-pencil" class="tiny medium-gray" aria-hidden="true"></svg-icon>
        </button>
      </div>
    </div>
    <div class="grid-x">
      @if (mapHasRelatedEntities(map)) {
        <div class="cell small-12 padding-left bold padding-left" style="font-size: .9rem;">
          Related Entities:
        </div>
      }
      @for (related of map.relatedEntityMaps; track related; let rel = $index) {
        <div class="cell small-12 padding-left reduce-font">
          @if (related.isDirty) {
            <label for="selectRelated">Select Related Entity:</label>
            <div class="grid-x">
              <div class="cell small-4">
                <div class="input-group">
                  <select class="white-bg no-margin" id="selectRelated"  (change)="relatedEntityChanged($event.target.value, map, rel)">
                    @for (entity of availableEntities; track entity) {
                      <option [selected]="entity.id === related.entity.id" [value]="entity.id">{{entity.entityName}}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="cell small-1 minor-margin-left">
                <label for="selField"> related by </label>
              </div>
              <div class="cell small-6 minor-margin-left">
                <div class="input-group">
                  <select class="white-bg no-margin" id="selField" (change)="relationalPropertyChanged($event.target.value, map, rel)">
                    @for (property of relationalPropertyOptions; track property) {
                      <option [value]="property.propertyName">{{property.propertyName}}</option>
                    }
                  </select>
                  <div class="input-group-button">
                    @if (addRelatedButtonDisabled(map, rel)) {
                      <span class="show-for-sr">Please Select a Related Entity to Enable This Button</span>
                    }
                    <button class="button" [attr.aria-label]="addRelatedButtonDisabled(map, rel) ? 'Please Select a Related Entity to Enabled This Button' : null" (click)="addRelatedEntity(related)" [disabled]="addRelatedButtonDisabled(map, rel)">Add Related Entity</button>
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <span>{{related.mapName}} - related by {{related.relationalProperty}}</span>
            <button class="float-right" title="Delete" (click)="deleteRelated(map, related, rel)" attr.aria-label="Delete Related Entity Map {{related.mapName}}">
              <span class="show-for-sr">Delete Related Entity Map {{related.mapName}}</span>
              <svg-icon icon="icon-trash" class="tiny medium-gray" aria-hidden="true"></svg-icon>
            </button>
            <button class="float-right" title="Edit" (click)="editRelated(related)" attr.aria-label="Edit Related Map {{related.mapName}}">
              <span class="show-for-sr">Edit Related Map {{related.mapName}}</span>
              <svg-icon icon="icon-pencil" class="tiny medium-gray" aria-hidden="true"></svg-icon>
            </button>
          }
        </div>
      }
    </div>
    <div class="grid-x">
      <div class="cell small-12 padding-left reduce-font">
        <button (click)="addNewRelated(map)">
          Add Related Entity
          <svg-icon icon="icon-plus" class="tiny medium-gray" aria-hidden="true"></svg-icon>
        </button>
      </div>
    </div>
  </div>
}
<confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
